import * as _ from 'lodash';
import moment from 'moment';
import 'moment-timezone'
import { v4 as uuid } from 'uuid'

export class SurveyDatabaseRecord {
    static objectStoreName: string

    public key: string

    public static apiRoute(filters?: any): string {
      return
    }

    protected static parseDate(date: string): moment.Moment {
      return moment.tz(date, 'Etc/UTC')
    }

    constructor(data: {
      key?: string,
      id?: string,
    } = {}
    ) {
      this.key = data.key || data.id || uuid()
    }

    toJSON(fields?: string[]) {
      const object = {
        key: this.key
      }

      if (_.isNil(fields)) {
        fields = []
      }

      _.each(fields, (field) => {
        let value = this[field]

        // look at the private cache of foreign records if we never loaded records
        // if (_.isNil(value) && !_.isNil(this['_' + field])) {
        //   value =
        // }

        if (!_.isNil(value)) {
          if (moment.isMoment(value)) {
            value = value.toDate()
          } else if (_.isArray(value) && _.size(value) > 0 && value[0] instanceof SurveyDatabaseRecord) {
            value = _.map(value, (record) => record.key)
          }

          object[field] = value
        }
      })

      return object
    }
}
